import { useEffect } from 'react';
import { useDrag } from 'react-dnd';

import type { ReportDnDColumnItemT, ReportMappedColumnT } from '../types';

type Props = {
  index: number;
  column: ReportMappedColumnT;
  setSomeDragging: (someDragging: boolean) => void;
};

const useReportCardDrag = (props: Props) => {
  const { index, setSomeDragging, column } = props;
  const [{ isDragging }, dragRef, previewRef] = useDrag<
    ReportDnDColumnItemT,
    unknown,
    { isDragging: boolean }
  >(() => {
    return {
      type: String(column.item.type),
      item: {
        column: column,
        rowIndex: column.row_index,
        rowId: column.row_alias,
      },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
      end: (_, monitor) => {
        const didDrop = monitor.didDrop();
        if (!didDrop) {
          //didDrop이 !(아니다)라는 것은 dropRef로 선언한 태그위에 드랍되지 않음 을 의미한다.
          //그때는 원래의 위치대로 이동.
        }
      },
    };
  }, [column, index]);

  useEffect(() => {
    isDragging ? setSomeDragging(true) : setSomeDragging(false);
  }, [isDragging, setSomeDragging]);

  return {
    dragRef,
    previewRef,
    isDragging,
  };
};

export default useReportCardDrag;
